module.exports = __webpack_public_path__ + "purple.edb85e03.png";